/**
 * Sendable assets card (SA-47).
 *
 * Surfaces per-persona asset grants inside the workshop Capabilities
 * section — previously reachable only via the legacy editor modal's Tools
 * tab (the buried path behind three empty-grants incidents). Wraps the
 * shared PersonaSendableAssetsSection; copy is deliberately asset-neutral
 * ("assets", not "files") ahead of SA-48's URL asset kind.
 */
import { Card } from '@/components/ui/Card'
import { useFeature } from '@/hooks/useFeature'
import { PersonaSendableAssetsSection } from '@/components/config/PersonaSendableAssetsSection'

export function SendableAssetsCard({
  personaId,
  personaName,
}: {
  personaId: string
  personaName: string
}) {
  const toolFrameworkOn = useFeature('tool_framework')
  if (!toolFrameworkOn) return null
  return (
    <Card className="p-6 gap-0">
      <h3 className="text-sm font-semibold text-foreground">Sendable assets</h3>
      <p className="mb-3 text-xs text-muted-foreground">
        Approved content {personaName} can share with customers.
      </p>
      <PersonaSendableAssetsSection personaId={personaId} hideHeader />
    </Card>
  )
}
